module.exports = __webpack_public_path__ + "img/叶坪博生堡.6652725e.png";